import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  ArrowCont,
  CheckQuestion,
  CheckQuestionCont,
  CheckQuestionPrefix,
  ExpandIcon,
  TileCont,
  Title,
  TitleCont,
  RecommendationCont,
  RecommendationText,
} from './RecommendationTile.styles';
import { ERecommendationVariant } from '../../../constans/report';
import { useFilters } from '../../../hooks/useFilters';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { IImprovementItem } from '../../../services/reports';

interface IRecommendationTile {
  improvement: IImprovementItem;
  variant: ERecommendationVariant;
  index: number;
  categoryCode: string;
}

const RecommendationTile: FC<IRecommendationTile> = ({
  improvement,
  variant,
  index,
  categoryCode,
}) => {
  const { t } = useTranslation();
  const { getVariantDetails } = useRecommendations();
  const { color } = getVariantDetails(variant);
  const { getNestedFilters, applyNestedFilter } = useFilters();
  const categoryKey = 'categories';
  const categoriesFilters = getNestedFilters(categoryKey);
  const active = _.includes(categoriesFilters[categoryCode]?.active, index) || false;

  const openRecommendation = () => {
    const isActive = !active;
    if (isActive) {
      const openedImprovements = categoriesFilters[categoryCode]?.active;
      applyNestedFilter(
        { active: isActive ? [...openedImprovements, index] : null },
        categoryCode,
        categoryKey
      );
    } else {
      const openedImprovements = categoriesFilters[categoryCode]?.active as number[];
      const newOpenedImprovements = openedImprovements.filter(value => value !== index);
      applyNestedFilter({ active: newOpenedImprovements }, categoryCode, categoryKey);
    }
  };

  return (
    <TileCont id="TileCont">
      <TitleCont id="TitleCont" onClick={() => openRecommendation()}>
        <ArrowCont id="ArrowCont">
          <ExpandIcon id="ExpandIcon" isExpanded={active} />
        </ArrowCont>
        <Title id="Title">{improvement.title}</Title>
      </TitleCont>
      {active && (
        <>
          <CheckQuestionCont id="CheckQuestionCont" color={color}>
            <CheckQuestionPrefix id="CheckQuestionPrefix">
              {t('report.recommendation.askYourTeam')}:
            </CheckQuestionPrefix>
            <CheckQuestion id="CheckQuestion">{improvement.checkQuestion}</CheckQuestion>
          </CheckQuestionCont>
          {improvement.recommendations.map((recommendation, index) => (
            <RecommendationCont
              key={index}
              id="RecommendationCont"
              isLast={index === improvement.recommendations.length - 1}
              isFirst={index === 0}
            >
              <RecommendationText id="RecommendationText">{recommendation}</RecommendationText>
            </RecommendationCont>
          ))}
        </>
      )}
    </TileCont>
  );
};

export default RecommendationTile;
